export enum PurchaseActionOption {
    UPDATE_FULFILLED_QUANTITY,
    UPDATE_QUANTITY,
    MESSAGE,
    RESEND_CONFIRMATION,
    RESEND_GRATUITY_EMAIL,
    CHANGE_ARRIVAL,
    MODIFY_GUESTS,
    CHARGE,
    COLLECT_BALANCE,
    REFUND,
    SWITCH_EXPERIENCE,
    CANCEL_RESERVATION,
    ADD_PURCHASE_NOTE,
    APPLY_CODE,
    EMAIL_RECEIPT,
    EDIT_PURCHASE_PRIVACY,
    RESEND_WAIVER_EMAIL,
    EDIT_ADD_ONS,
    REBOOK_ORGANIZER,
    LINK_WAIVER_FOR_PURCHASE,
    LINK_WAIVER_FOR_GUEST,
    COLLECT_BALANCE_VIA_INVOICE,
    COLLECT_BALANCE_OPTIONS,
    ADD_FUNDS,
    ADJUST_BALANCE,

    REFUND_GIFT_OR_STORE_CREDIT,
    REFUND_GIFT,

    SEND_CERTIFICATE,
    SEND_GIFT_RECEIPT_EMAIL,
    SEND_STORE_CREDIT_EMAIL,
    PRINT_RECEIPT,
    EXPORT_TICKET,
    PRINT_GIFT_CERTIFICATE,
    SEND_GIFT_CERTIFICATE_TO_RECIPIENT,

    SEND_MEMBERSHIP_EMAIL,

    UNASSIGN_GUIDE,

    REMOVE_MEMBERSHIP_CODE,
    MODIFY_GRATUITY,

    SPLIT_PACKAGE,
}
